export const PREFERRED_LANGUAGE_COOKIE_NAME = "preferred-language";
